import React from 'react';
import '../less/index';
import FilesForDownload from '../../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import { Preloader } from "MWComponents";
import SliderComponent from "../../../../auxiliary-components/shared/Slider";
import DOMPurify from 'utils/sanitize';
import UsageBlock from "../../../../auxiliary-components/shared/UsageBlock";
import usage_block_data from "../enums/usage_block_data.json";
import winners_block_img from "../img/winners-block-img.png";

export default function template() {
    const isMobile = this.isViewportMobile(),
      scheduleStageData = [
        {stage: 'HAPPY_ATB_WINNERS_SCHEDULE_TITLE_01', gift: 'HAPPY_ATB_WINNERS_SCHEDULE_TEXT_01'},
        {stage: 'HAPPY_ATB_WINNERS_SCHEDULE_TITLE_02', gift: 'HAPPY_ATB_WINNERS_SCHEDULE_TEXT_02'},
        {stage: 'HAPPY_ATB_WINNERS_SCHEDULE_TITLE_03', gift: 'HAPPY_ATB_WINNERS_SCHEDULE_TEXT_03'},
        {stage: 'HAPPY_ATB_WINNERS_SCHEDULE_TITLE_04', gift: 'HAPPY_ATB_WINNERS_SCHEDULE_TEXT_04'},
        {stage: 'HAPPY_ATB_WINNERS_SCHEDULE_TITLE_05', gift: 'HAPPY_ATB_WINNERS_SCHEDULE_TEXT_05'},
      ],
      scheduleStageBlock = scheduleStageData.map(el => {
        return(
          <div className="winners-block-schedule-list-item" key={el.stage}>
            <div className="winners-block-schedule-list-item-title">{this.l10n(el.stage)}</div>
            <div className="winners-block-schedule-list-item-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(el.gift))  }}></div>
          </div>
        )
      });

    return (
      <div className="happy-atb-module">
          <div className="slider-container">
              {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile}
                                                                              widget={this.widgetsHelper.getWidget.call(this, "main_banner")}></SliderComponent>}
          </div>
          <div className="content">
            <div className="title bold">{this.l10n("HAPPY_ATB_TITLE")}</div>
            <div className="info-block">
              <div className="info-block-text first" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n('HAPPY_ATB_INFO_BLOCK_TEXT_1')) }}></div>
              <div className="info-block-text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n('HAPPY_ATB_INFO_BLOCK_TEXT_2')) }}></div>
            </div>
            <UsageBlock
              isMobile={isMobile}
              page={'happy-atb'}
              data={usage_block_data}
              className='col-2-row-2'
            ></UsageBlock>
            <div className="title bold">{this.l10n('HAPPY_ATB_WINNERS_TITLE_01')}</div>
            <div className="text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('HAPPY_ATB_WINNERS_TEXT_01'))}}></div>
            <div className="winners-block">
              <div className="winners-block-schedule">
                <div className="title">{this.l10n('HAPPY_ATB_WINNERS_TITLE_02')}</div>
                <div className="winners-block-schedule-list">
                  {scheduleStageBlock}
                </div>
              </div>
              <img className="winners-block-img" src={winners_block_img} alt="winners-block-img"/>
            </div>

              <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')} />
          </div>
      </div>
    );
}
